import { Box } from "@mui/material";

import { IconIssueClose } from "../../../common/utils/icons";

interface ISnapShotProps {
  snapShotData?: any;
  setSnapShotData?: any;
}
const IssuesListSnapShot = ({
  snapShotData,
  setSnapShotData,
}: ISnapShotProps) => {
  const handleClose = () => {
    setSnapShotData((prev: any) => ({
      ...prev,
      isVisible: false,
      snapShotData: [],
      isBackDropVisible: false,
    }));
  };
  // Helper function to safely extract entries from snapshot data
  const getSafeEntries = (data: any): [string, any][] | null => {
    try {
      // Check if data exists and is a valid object (not array, null, or primitive)
      if (!data || typeof data !== "object" || Array.isArray(data)) {
        return null;
      }
      return Object.entries(data);
    } catch (error) {
      console.error("Error processing snapshot data:", error);
      return null;
    }
  };

  // Function to render table content based on data state
  const renderTableContent = () => {
    const entries = getSafeEntries(snapShotData?.snapShotData);

    // If data is invalid or null, don't render any rows
    if (entries === null) {
      return null;
    }

    // If data is valid but empty, show N/A row
    if (entries.length === 0) {
      return (
        <tr>
          <td>N/A</td>
          <td>
            <Box className="word-break-all">N/A</Box>
          </td>
        </tr>
      );
    }

    // Render actual data rows
    return entries.map(([key, value], index) => (
      <tr key={index}>
        <td>{key}</td>
        <td>
          <Box className="word-break-all">{value ?? "N/A"}</Box>
        </td>
      </tr>
    ));
  };

  return (
    <>
      <Box
        className={`filter-sidebar large-panel
        ${snapShotData?.isVisible ? "show" : "hide"}`}
      >
        <div className="filter-header">
          SnapShot Data
          <div className="close-filter" onClick={handleClose}>
            <IconIssueClose />
          </div>
        </div>
        <div className="filter-body">
          <Box
            className="incident-resources"
            sx={{ maxHeight: "60vh", overflowY: "auto" }}
          >
            <table className="table1">
              <tbody>{renderTableContent()}</tbody>
            </table>
          </Box>
        </div>
      </Box>
    </>
  );
};

export default IssuesListSnapShot;
